export const LayoutToggle = Object.freeze({
  TILE: 0,
  LIST: 1,
  MAP: 2,
})
